/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V
// Component: l_mDiRcfmDZh

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGPresetMessage } from "@lg-plus/landing-components/LGPresetMessage"; // plasmic-import: fEZTQ14xlGMr/codeComponent
import SliderForm from "../../SliderForm"; // plasmic-import: _rQb9zd5dUuy/component
import { LGCTAButton } from "@lg-plus/landing-components"; // plasmic-import: aVbs4C93GDUm/codeComponent
import PrimaryButton from "../../PrimaryButton"; // plasmic-import: vB7QgUC5rmaN/component
import Zpusob from "../../Zpusob"; // plasmic-import: ToLqVzUyYUyT/component
import FaqItem from "../../FaqItem"; // plasmic-import: 14ObDxab2_fA/component
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import Review from "../../Review"; // plasmic-import: XBLIF8bf7Q7W/component
import CsLinkButton from "../../CsLinkButton"; // plasmic-import: VcTnMTc7AXRY/component
import Footer from "../../Footer"; // plasmic-import: Mqdcjk2nDySW/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomepage.module.css"; // plasmic-import: l_mDiRcfmDZh/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: CMNsVVM_CTAi/icon
import ChevronDown2Icon from "./icons/PlasmicIcon__ChevronDown2"; // plasmic-import: HOj16Al_mbLY/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: Zq-a6r-hP9jd/icon
import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: zK5RHdivFAeU/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: kstG8dyLQaka/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: -8LoEpBDO1A3/icon
import StarSvgIcon from "../credit_storm_2_redesigned/icons/PlasmicIcon__StarSvg"; // plasmic-import: wf0Y7SiG9qtu/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Půjčka bleskově | 30ka.cz",

    openGraph: {
      title: "Půjčka bleskově | 30ka.cz"
    },
    twitter: {
      card: "summary" as const,
      title: "Půjčka bleskově | 30ka.cz"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>("children");

export type PlasmicHomepage__OverridesType = {
  homepageWrapper?: Flex__<"div">;
  invalidLinkMessage?: Flex__<typeof LGPresetMessage>;
  mainSection?: Flex__<"section">;
  sliderForm?: Flex__<typeof SliderForm>;
  faqSection?: Flex__<"section">;
  section?: Flex__<"section">;
  reviewsSection?: Flex__<"section">;
  reviews?: Flex__<typeof SliderWrapper>;
  staticReviewsSection?: Flex__<"section">;
  subfooter?: Flex__<"section">;
  sliderFormBottom?: Flex__<typeof SliderForm>;
  csLinkButton?: Flex__<typeof CsLinkButton>;
  footer?: Flex__<typeof Footer>;
};

export interface DefaultHomepageProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "reviews.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "reviews",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      },
      {
        path: "sliderForm.amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "sliderFormBottom.amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"homepageWrapper"}
          data-plasmic-override={overrides.homepageWrapper}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_wboCjrKjkicgLwUG7d8r4V",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.homepageWrapper,
            {
              [sty.homepageWrapperglobal_tmp_override]: hasVariant(
                globalVariants,
                "tmp",
                "override"
              )
            }
          )}
        >
          <LGPresetMessage
            data-plasmic-name={"invalidLinkMessage"}
            data-plasmic-override={overrides.invalidLinkMessage}
            className={classNames("__wab_instance", sty.invalidLinkMessage)}
            content={
              "Tento odkaz je neplatn\u00fd nebo jeho platnost vypr\u0161ela."
            }
            isDynamic={true}
            preset={"INVALID_LINK"}
          />

          <section
            data-plasmic-name={"mainSection"}
            data-plasmic-override={overrides.mainSection}
            className={classNames("all", sty.mainSection)}
          >
            <div className={classNames("all", "__wab_text", sty.text__haxfx)}>
              {"\u2191"}
            </div>
            <div className={classNames("all", sty.freeBox__uzSxS)}>
              <div className={classNames("all", sty.freeBox__qDkz6)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__pRpf)}
                  displayHeight={"36px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: "/plasmic/credit_storm_2_redesigned/images/logoCs2Svg.svg",
                    fullWidth: 1543,
                    fullHeight: 426,
                    aspectRatio: undefined
                  }}
                />

                <h1
                  className={classNames(
                    "all",
                    "h1",
                    "h1__wboCj",
                    "__wab_text",
                    sty.h1__lOsN0,
                    {
                      [sty.h1global_tmp_override__lOsN01Whfc]: hasVariant(
                        globalVariants,
                        "tmp",
                        "override"
                      )
                    }
                  )}
                >
                  {
                    "Va\u0161e p\u0159\u00edle\u017eitost z\u00edskat lep\u0161\u00ed p\u016fj\u010dku je\u00a0tady!"
                  }
                </h1>
                <div className={classNames("all", sty.freeBox___1HhLg)}>
                  <SliderForm
                    data-plasmic-name={"sliderForm"}
                    data-plasmic-override={overrides.sliderForm}
                    className={classNames("__wab_instance", sty.sliderForm)}
                    onAmountChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "sliderForm",
                        "amount"
                      ]).apply(null, eventArgs);

                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }
                    }}
                  >
                    <div className={classNames("all", sty.freeBox__hE17)}>
                      <LGCTAButton
                        amount={$state.sliderForm.amount ?? 17000}
                        buttonSlot={
                          <PrimaryButton
                            className={classNames(
                              "__wab_instance",
                              sty.primaryButton__bwsef
                            )}
                            label={
                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__a25Xk
                                )}
                              >
                                {"P\u016fj\u010dit v\u00fdhodn\u011b te\u010f"}
                              </div>
                            }
                          />
                        }
                        className={classNames(
                          "__wab_instance",
                          sty.lgctaButton__kiTkq
                        )}
                      />
                    </div>
                  </SliderForm>
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__z1Ow)} />
            </div>
            <div className={classNames("all", sty.freeBox__fH9Su)}>
              <h1
                className={classNames(
                  "all",
                  "h1",
                  "h1__wboCj",
                  "__wab_text",
                  sty.h1__gVkPa
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {"Pro\u010d po\u017e\u00e1dat o p\u016fj\u010dku \n"}
                  </React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__wboCj"
                    }
                    style={{ color: "var(--token-uT9a9OFFhtzq)" }}
                  >
                    {"na 30ka.cz?"}
                  </span>
                </React.Fragment>
              </h1>
              <div className={classNames("all", sty.freeBox__lBtby)}>
                <div className={classNames("all", sty.freeBox__dgwgO)}>
                  <div className={classNames("all", sty.freeBox__bcLbk)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__tkqJy)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"66px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/images/wallet3.png",
                        fullWidth: 134,
                        fullHeight: 134,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__rwKk)}
                  >
                    {hasVariant(globalVariants, "screen", "mobile")
                      ? "Vy\u0159\u00edzen\u00ed ZDARMA"
                      : hasVariant(globalVariants, "screen", "tablet")
                        ? "Vy\u0159\u00edzen\u00ed\nZDARMA"
                        : "Vy\u0159\u00edzen\u00ed ZDARMA"}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__nw7F9)}
                  >
                    {"Neplat\u00edte \u017e\u00e1dn\u00e9 poplatky p\u0159edem"}
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox__mHv9S)}>
                  <div className={classNames("all", sty.freeBox__aUnbr)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__xR9R)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"66px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/images/thunderPng.png",
                        fullWidth: 134,
                        fullHeight: 134,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__pk6C)}
                  >
                    {"V\u00fdsledek v\u00edte do 5 minut"}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__j0S4H)}
                  >
                    {
                      "Sta\u010d\u00ed vyplnit jednoduchou \u017e\u00e1dost online"
                    }
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox__odPK)}>
                  <div className={classNames("all", sty.freeBox__rrUgQ)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__saiHx)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"66px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/images/coinPng.png",
                        fullWidth: 134,
                        fullHeight: 134,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__sIrtW)}
                  >
                    {"Pen\u00edze pos\u00edl\u00e1me bleskov\u011b"}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__tbx1W)}
                  >
                    {
                      "P\u016fj\u010dka doraz\u00ed na \u00fa\u010det ihned po schv\u00e1len\u00ed"
                    }
                  </div>
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__vqjdx)}>
                <LGCTAButton
                  amount={$state.sliderForm.amount ?? 17000}
                  buttonSlot={
                    <PrimaryButton
                      className={classNames(
                        "__wab_instance",
                        sty.primaryButton__ktl84
                      )}
                      color={"purple"}
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__zigHa
                          )}
                        >
                          {"P\u016fj\u010dit v\u00fdhodn\u011b te\u010f"}
                        </div>
                      }
                    />
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.lgctaButton__qrsSp
                  )}
                  id={"cta-btn-2"}
                />
              </div>
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__wboCj",
                "__wab_text",
                sty.h1__gEk0N
              )}
              id={"jaknato"}
            >
              {
                "Jak\u00fdm zp\u016fsobem mohu po\u017e\u00e1dat o p\u016fj\u010dku?"
              }
            </h1>
            <div className={classNames("all", sty.freeBox___8Qvse)}>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__b2RGz)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__mqc2P)}
                  >
                    {"Po\u0161lete \u017e\u00e1dost"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__oGAvK)}
                  >
                    {
                      "Vypl\u0148te online formul\u00e1\u0159 na na\u0161em webu \u2014 je to jednoduch\u00e9 a rychl\u00e9"
                    }
                  </div>
                }
              />

              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__nH1T6)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__izmZ0)}
                  >
                    {"P\u0159ipravte si doklady"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__nckuu)}
                  >
                    {
                      "Kopii platn\u00e9ho ob\u010dansk\u00e9ho pr\u016fkazu, druh\u00fd doklad toto\u017enosti, V\u00fdpis z bankovn\u00edho \u00fa\u010dtu nebo v\u00fdplatn\u00ed p\u00e1sky za posledn\u00ed 3 m\u011bs\u00edce"
                    }
                  </div>
                }
              >
                {renderPlasmicSlot({
                  defaultContents: (
                    <Icon3Icon
                      className={classNames("all", sty.svg__clNsJ)}
                      role={"img"}
                    />
                  ),

                  value: args.children
                })}
              </Zpusob>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob___6PVpO)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__gsg73)}
                  >
                    {"Schv\u00e1len\u00ed \u017e\u00e1dosti"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__r931N)}
                  >
                    {
                      "Va\u0161i \u017e\u00e1dost posoud\u00edme bez poplatku a d\u00e1me v\u00e1m v\u011bd\u011bt v\u00fdsledek"
                    }
                  </div>
                }
              >
                <Icon4Icon
                  className={classNames("all", sty.svg__sIaJe)}
                  role={"img"}
                />
              </Zpusob>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob___8Aj8W)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__qvdpE)}
                  >
                    {"Z\u00edskejte pen\u00edze"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__wawQg)}
                  >
                    {
                      "Po schv\u00e1len\u00ed v\u00e1m p\u0159evedeme \u010d\u00e1stku od 1000 K\u010d do 30 000 K\u010d na v\u00e1\u0161 \u00fa\u010det"
                    }
                  </div>
                }
              >
                <Icon5Icon
                  className={classNames("all", sty.svg__ieF1)}
                  role={"img"}
                />
              </Zpusob>
            </div>
          </section>
          <section
            data-plasmic-name={"faqSection"}
            data-plasmic-override={overrides.faqSection}
            className={classNames("all", sty.faqSection)}
          >
            <section
              data-plasmic-name={"section"}
              data-plasmic-override={overrides.section}
              className={classNames("all", sty.section)}
            >
              <div className={classNames("all", sty.freeBox__e0PnF)}>
                <h3
                  className={classNames(
                    "all",
                    "h3",
                    "h3__wboCj",
                    "__wab_text",
                    sty.h3__pToEr
                  )}
                  id={"faq"}
                >
                  {"\u010casto se n\u00e1s pt\u00e1te"}
                </h3>
                <FaqItem
                  className={classNames("__wab_instance", sty.faqItem__tDvf)}
                  slot={
                    "Nemus\u00edte. P\u016fj\u010dka je bez\u00fa\u010delov\u00e1, tak\u017ee pen\u00edze m\u016f\u017eete vyu\u017e\u00edt na cokoliv, a\u0165 u\u017e jde o rekonstrukci, nov\u00e9 auto, \u0161kolu nebo dovolenou.\n\nNept\u00e1me se, na co p\u016fj\u010dku pot\u0159ebujete, a nic nemus\u00edte dokl\u00e1dat. V\u0161echno je bez zbyte\u010dn\u00e9ho pap\u00edrov\u00e1n\u00ed. Pen\u00edze jsou prost\u011b va\u0161e."
                  }
                >
                  {"Mus\u00edm uv\u00e1d\u011bt, na co si p\u016fj\u010duji?"}
                </FaqItem>
                <FaqItem
                  className={classNames("__wab_instance", sty.faqItem___462DW)}
                  slot={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___4Uo14
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "Abyste mohli p\u016fj\u010dku z\u00edskat, je pot\u0159eba splnit n\u011bkolik z\u00e1kladn\u00edch po\u017eadavk\u016f:\n\n"
                          }
                        </React.Fragment>
                        {
                          <ul
                            className={classNames(
                              "all",
                              "ul",
                              "ul__wboCj",
                              sty.ul__jCXg5
                            )}
                          >
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__rRnlb
                              )}
                            >
                              {
                                "ob\u010danstv\u00ed \u010cR s trval\u00fdm pobytem\n"
                              }
                            </li>
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__yIkvj
                              )}
                            >
                              {"v\u011bk v rozmez\u00ed 18 a\u017e 75 let\n"}
                            </li>
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li___9BdOk
                              )}
                            >
                              {
                                "dolo\u017eiteln\u00fd pravideln\u00fd p\u0159\u00edjem"
                              }
                            </li>
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__bgKg1
                              )}
                            >
                              {
                                "bankovn\u00ed \u00fa\u010det veden\u00fd na va\u0161e jm\u00e9no"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>
                          {
                            "\nZ\u00e1rove\u0148 je d\u016fle\u017eit\u00e9, abyste byli schopni p\u016fj\u010dku v\u010das a \u0159\u00e1dn\u011b spl\u00e1cet podle dohodnut\u00fdch podm\u00ednek."
                          }
                        </React.Fragment>
                      </React.Fragment>
                    </div>
                  }
                >
                  {
                    "Jak\u00e9 jsou podm\u00ednky pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky?"
                  }
                </FaqItem>
                <FaqItem
                  className={classNames("__wab_instance", sty.faqItem__kdLI)}
                  slot={
                    "Ne, za pod\u00e1n\u00ed \u017e\u00e1dosti ani schv\u00e1len\u00ed p\u016fj\u010dky nic neplat\u00edte. V\u0161e je zdarma a bez skryt\u00fdch poplatk\u016f.\n\nP\u0159\u00edpadn\u00e9 n\u00e1klady (nap\u0159. za veden\u00ed \u00fav\u011bru nebo odklad spl\u00e1tek) se t\u00fdkaj\u00ed jen dopl\u0148kov\u00fdch slu\u017eeb, kter\u00e9 si zvol\u00edte sami, v\u017edy o nich budete p\u0159edem informov\u00e1ni ve smlouv\u011b."
                  }
                >
                  {
                    "Plat\u00ed se n\u011bco za vy\u0159\u00edzen\u00ed p\u016fj\u010dky?"
                  }
                </FaqItem>
                <FaqItem
                  className={classNames("__wab_instance", sty.faqItem___9OKkN)}
                  slot={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__kQrhd
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "K vy\u0159\u00edzen\u00ed p\u016fj\u010dky je pot\u0159eba dolo\u017eit p\u00e1r z\u00e1kladn\u00edch dokument\u016f, kter\u00e9 slou\u017e\u00ed k ov\u011b\u0159en\u00ed toto\u017enosti a p\u0159\u00edjmu:\n\n"
                          }
                        </React.Fragment>
                        {
                          <ul
                            className={classNames(
                              "all",
                              "ul",
                              "ul__wboCj",
                              sty.ul___2WH3U
                            )}
                          >
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__xXclH
                              )}
                            >
                              {"platn\u00fd ob\u010dansk\u00fd pr\u016fkaz"}
                            </li>
                          </ul>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              "all",
                              "ul",
                              "ul__wboCj",
                              sty.ul__hoFCw
                            )}
                          >
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__he1Pw
                              )}
                            >
                              {
                                "druh\u00fd doklad toto\u017enosti (nap\u0159. \u0159idi\u010d\u00e1k, pas nebo rodn\u00fd list)"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              "all",
                              "ul",
                              "ul__wboCj",
                              sty.ul__m3MQ
                            )}
                          >
                            <li
                              className={classNames(
                                "all",
                                "li",
                                "li__wboCj",
                                "__wab_text",
                                sty.li__g3UP
                              )}
                            >
                              {
                                "potvrzen\u00ed o p\u0159\u00edjmu \u2013 bu\u010f v\u00fdplatn\u00ed p\u00e1sky nebo v\u00fdpis z \u00fa\u010dtu za posledn\u00ed 3 m\u011bs\u00edce"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>
                          {
                            "\nV n\u011bkter\u00fdch p\u0159\u00edpadech m\u016f\u017ee poskytovatel cht\u00edt i dal\u0161\u00ed dokumenty, nap\u0159. potvrzen\u00ed o trval\u00e9m pobytu nebo \u010d\u00edslo \u00fa\u010dtu, kam v\u00e1m maj\u00ed p\u0159ij\u00edt pen\u00edze.\n\n\ud83d\udc49 Doporu\u010dujeme m\u00edt v\u0161e aktu\u00e1ln\u00ed \u2013 urychl\u00ed to schv\u00e1len\u00ed."
                          }
                        </React.Fragment>
                      </React.Fragment>
                    </div>
                  }
                >
                  {
                    "Jak\u00e9 doklady budu pot\u0159ebovat k \u017e\u00e1dosti o p\u016fj\u010dku?"
                  }
                </FaqItem>
                <FaqItem
                  className={classNames("__wab_instance", sty.faqItem__c0Sot)}
                  slot={
                    "Po schv\u00e1len\u00ed jsou pen\u00edze odesl\u00e1ny b\u011bhem n\u011bkolika minut. Rychlost p\u0159ips\u00e1n\u00ed z\u00e1vis\u00ed na va\u0161\u00ed bance."
                  }
                >
                  {"Kdy dostanu pen\u00edze na \u00fa\u010det?"}
                </FaqItem>
              </div>
            </section>
          </section>
          <section
            data-plasmic-name={"reviewsSection"}
            data-plasmic-override={overrides.reviewsSection}
            className={classNames("all", sty.reviewsSection)}
          >
            <h3
              className={classNames(
                "all",
                "h3",
                "h3__wboCj",
                "__wab_text",
                sty.h3__sThl8
              )}
            >
              {"Co \u0159\u00edkaj\u00ed na\u0161i klienti"}
            </h3>
            {(() => {
              const child$Props = {
                arrows: true,
                autoplay: false,
                autoplaySpeed: 0,
                beforeChange: async (...eventArgs: any) => {
                  generateStateOnChangePropForCodeComponents(
                    $state,
                    "currentSlide",
                    ["reviews", "currentSlide"],
                    SliderWrapper_Helpers
                  ).apply(null, eventArgs);
                },
                centerMode: true,
                className: classNames("__wab_instance", sty.reviews),
                cssEase: "linear",
                dots: true,
                initialSlide: generateStateValueProp($state, [
                  "reviews",
                  "currentSlide"
                ]),
                ref: ref => {
                  $refs["reviews"] = ref;
                },
                sliderScopeClassName: sty["reviews__slider"],
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: 500,
                variableWidth: false
              };
              initializeCodeComponentStates(
                $state,
                [
                  {
                    name: "currentSlide",
                    plasmicStateName: "reviews.currentSlide"
                  }
                ],
                [],
                SliderWrapper_Helpers ?? {},
                child$Props
              );

              return (
                <SliderWrapper
                  data-plasmic-name={"reviews"}
                  data-plasmic-override={overrides.reviews}
                  {...child$Props}
                >
                  <div className={classNames("all", sty.freeBox__qPbL)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__oi5GX
                      )}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__br2PK)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__o4QB0
                      )}
                      slot2={"Lucie H., 26 let"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__vosFq)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__hh9Qy
                      )}
                      slot2={"Tom\u00e1\u0161 V., 59 let"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__huDj2)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__hVcWd
                      )}
                      slot2={"Monika K., 33 let"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__prHo4)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__uqFmQ
                      )}
                      slot2={"Petra N., 56 let"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__l51Of)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__wlfL7
                      )}
                      slot2={"Martin B., 35 let"}
                    />
                  </div>
                </SliderWrapper>
              );
            })()}
          </section>
          <section
            data-plasmic-name={"staticReviewsSection"}
            data-plasmic-override={overrides.staticReviewsSection}
            className={classNames("all", sty.staticReviewsSection)}
          >
            <div className={classNames("all", sty.freeBox___5TPi3)}>
              <h1
                className={classNames(
                  "all",
                  "h1",
                  "h1__wboCj",
                  "__wab_text",
                  sty.h1__ld5BG
                )}
              >
                {"Co \u0159\u00edkaj\u00ed na\u0161i z\u00e1kazn\u00edci"}
              </h1>
              <div className={classNames("all", sty.columns__rkoK)}>
                <div className={classNames("all", sty.column___574Qp)}>
                  <Review
                    className={classNames("__wab_instance", sty.review__mQh98)}
                    slot2={"Veronika S., 55 let"}
                  >
                    {
                      "Zrovna jsem \u0159e\u0161ila rozbit\u00fd kotel. Oprava prob\u011bhla bez odkladu, d\u00edky p\u016fj\u010dce od 30ka.cz a p\u0159\u00edjemn\u00e9 slev\u011b."
                    }
                  </Review>
                </div>
                <div className={classNames("all", sty.column__tylDi)}>
                  <Review
                    className={classNames("__wab_instance", sty.review__dEFhO)}
                    slot2={"Jan K., 32 let"}
                  >
                    {
                      "Pot\u0159eboval jsem vy\u0159e\u0161it ne\u010dekan\u00fd v\u00fddaj doma. Cel\u00e9 online, bez vol\u00e1n\u00ed a zbyte\u010dn\u00fdch komplikac\u00ed. Tohle byla fakt pomoc. D\u011bkuji."
                    }
                  </Review>
                </div>
                <div className={classNames("all", sty.column__wDMb)}>
                  <Review
                    className={classNames("__wab_instance", sty.review__toK1E)}
                    slot2={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text___1Pe6
                        )}
                      >
                        {"V\u00e1clav O., 45 let"}
                      </div>
                    }
                  >
                    {
                      "Byl jsem v trochu napjat\u00e9 situaci a ne\u010dekal jsem, \u017ee mi n\u011bkdo nab\u00eddne je\u0161t\u011b slevu na p\u016fj\u010dku. Pomohlo mi to v\u00edc, ne\u017e jsem \u010dekal."
                    }
                  </Review>
                </div>
              </div>
              <div className={classNames("all", sty.columns__dTn3R)}>
                <div className={classNames("all", sty.column__jnxPn)}>
                  <Review
                    className={classNames("__wab_instance", sty.review__z4A26)}
                    slot2={"Milan H., 41 let"}
                  >
                    {
                      "Na nic si nehrajou. V\u0161echno prob\u011bhlo jednodu\u0161e, dostal jsem p\u0159esn\u011b to, co sl\u00edbili, a je\u0161t\u011b v\u00fdhodn\u011bji, ne\u017e jsem \u010dekal."
                    }
                  </Review>
                </div>
                <div className={classNames("all", sty.column__tk0LR)}>
                  <Review
                    className={classNames("__wab_instance", sty.review___55ZNa)}
                    slot2={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__rx3HB
                        )}
                      >
                        {"Kate\u0159ina B., 30 let"}
                      </div>
                    }
                  >
                    {
                      "Pot\u0159ebovala jsem pokr\u00fdt \u0161koln\u00ed v\u00fddaje pro dceru. V\u0161echno bylo rychle, bez stresu, a sleva na p\u016fj\u010dku se fakt hodila."
                    }
                  </Review>
                </div>
                <div className={classNames("all", sty.column___48RIj)}>
                  <Review
                    className={classNames("__wab_instance", sty.review__oflos)}
                    slot2={"Petr P., 24 let"}
                  >
                    {
                      "Vyplnil jsem v\u0161echny \u00fadaje a do 15 minut jsem m\u011bl pen\u00edze na \u00fa\u010dtu. A fakt bez \u017e\u00e1dn\u00fdch skryt\u00fdch poplatk\u016f. D\u00edky!"
                    }
                  </Review>
                </div>
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"subfooter"}
            data-plasmic-override={overrides.subfooter}
            className={classNames("all", sty.subfooter)}
          >
            <div className={classNames("all", sty.freeBox__gUjzC)}>
              <div className={classNames("all", sty.freeBox__qh2Y1)}>
                <h3
                  className={classNames(
                    "all",
                    "h3",
                    "h3__wboCj",
                    "__wab_text",
                    sty.h3__fvDf9
                  )}
                >
                  {"Registrace"}
                </h3>
                <div
                  className={classNames("all", "__wab_text", sty.text__vhLsa)}
                >
                  {
                    "Je\u0161t\u011b se nezn\u00e1me, a proto od v\u00e1s pot\u0159ebujeme p\u00e1r \u00fadaj\u016f, abychom v\u00e1m mohli p\u016fj\u010dit pen\u00edze."
                  }
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__qjG7Y)}>
                <SliderForm
                  data-plasmic-name={"sliderFormBottom"}
                  data-plasmic-override={overrides.sliderFormBottom}
                  className={classNames("__wab_instance", sty.sliderFormBottom)}
                  onAmountChange={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "sliderFormBottom",
                      "amount"
                    ]).apply(null, eventArgs);

                    if (
                      eventArgs.length > 1 &&
                      eventArgs[1] &&
                      eventArgs[1]._plasmic_state_init_
                    ) {
                      return;
                    }
                  }}
                >
                  <CsLinkButton
                    data-plasmic-name={"csLinkButton"}
                    data-plasmic-override={overrides.csLinkButton}
                    className={classNames("__wab_instance", sty.csLinkButton)}
                    destination={`/apply?amount=${(() => {
                      try {
                        return $state.sliderFormBottom.amount;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return ``;
                        }
                        throw e;
                      }
                    })()}`}
                    label={"Z\u00cdSKAT PEN\u00cdZE"}
                  />
                </SliderForm>
              </div>
            </div>
          </section>
          <div className={classNames("all", sty.freeBox__b3Wek)}>
            <LGCTAButton
              amount={$state.sliderForm.amount ?? 17000}
              buttonSlot={
                <div className={classNames("all", sty.freeBox__wtzWg)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__l4BXa)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={
                      hasVariant(globalVariants, "screen", "mobile")
                        ? "50px"
                        : "90px"
                    }
                    loading={"lazy"}
                    src={{
                      src: "/plasmic/redesigned_credit_storm_landing_app_credit_storm_2/images/flashcoin.png",
                      fullWidth: 180,
                      fullHeight: 180,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___0Yc1V
                    )}
                  >
                    {"Chci levnou p\u016fj\u010dku"}
                  </div>
                </div>
              }
              className={classNames("__wab_instance", sty.lgctaButton__u0Qc)}
              id={"cta-btn-3"}
            />
          </div>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  homepageWrapper: [
    "homepageWrapper",
    "invalidLinkMessage",
    "mainSection",
    "sliderForm",
    "faqSection",
    "section",
    "reviewsSection",
    "reviews",
    "staticReviewsSection",
    "subfooter",
    "sliderFormBottom",
    "csLinkButton",
    "footer"
  ],
  invalidLinkMessage: ["invalidLinkMessage"],
  mainSection: ["mainSection", "sliderForm"],
  sliderForm: ["sliderForm"],
  faqSection: ["faqSection", "section"],
  section: ["section"],
  reviewsSection: ["reviewsSection", "reviews"],
  reviews: ["reviews"],
  staticReviewsSection: ["staticReviewsSection"],
  subfooter: ["subfooter", "sliderFormBottom", "csLinkButton"],
  sliderFormBottom: ["sliderFormBottom", "csLinkButton"],
  csLinkButton: ["csLinkButton"],
  footer: ["footer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  homepageWrapper: "div";
  invalidLinkMessage: typeof LGPresetMessage;
  mainSection: "section";
  sliderForm: typeof SliderForm;
  faqSection: "section";
  section: "section";
  reviewsSection: "section";
  reviews: typeof SliderWrapper;
  staticReviewsSection: "section";
  subfooter: "section";
  sliderFormBottom: typeof SliderForm;
  csLinkButton: typeof CsLinkButton;
  footer: typeof Footer;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "homepageWrapper") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("homepageWrapper"),
  {
    // Helper components rendering sub-elements
    invalidLinkMessage: makeNodeComponent("invalidLinkMessage"),
    mainSection: makeNodeComponent("mainSection"),
    sliderForm: makeNodeComponent("sliderForm"),
    faqSection: makeNodeComponent("faqSection"),
    section: makeNodeComponent("section"),
    reviewsSection: makeNodeComponent("reviewsSection"),
    reviews: makeNodeComponent("reviews"),
    staticReviewsSection: makeNodeComponent("staticReviewsSection"),
    subfooter: makeNodeComponent("subfooter"),
    sliderFormBottom: makeNodeComponent("sliderFormBottom"),
    csLinkButton: makeNodeComponent("csLinkButton"),
    footer: makeNodeComponent("footer"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
